import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Grid, TextField } from "@mui/material";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import { images } from "../../../config/images";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Button } from "../../../components/Button/button";
import Loader from "../../../components/Loader/Loader";
import PrivacyPolicy from "../../../components/Privacy/Privacy";
import { ToastContainer, toast } from "react-toastify";
import OTPInput, { ResendOTP } from "otp-input-react";
import { signInApi, verifyuser } from "../service";
import { setUserDetails } from "../slice/userSlice";
import { getModule } from "../../FootFallReport/services";


const LoginWithOtp = ({ mobileNo, onCancelClick }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [isLoading, setLoading] = useState(false);
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(60);
    const [visibleOTP, setvisibleOTP] = useState(false);

    const [OTP, setOTP] = useState();

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    const notify = (message) => {
        toast.error(message, {
            theme: "colored",
            position: toast.POSITION.TOP_RIGHT,
            toastClassName: "custom-toast",
        });
    };

    const notifySuccess = (message) => {
        toast.success(message, {
            theme: "colored",
            position: toast.POSITION.TOP_RIGHT,
            toastClassName: "custom-toast",
        });
    };

    // Update validity when form values change

    const handleResendOTp = async () => {
        try {
            const params = {
                mobile_no: `91${mobileNo}`,  // Add 91 as a prefix
            }
            setLoading(true);
            const resp = await verifyuser(params);
            if (resp.data.success == true) {
                setLoading(false);
                notifySuccess("Otp resend");
            }
        } catch (error) {
            console.log("error resending otp");
        }
    };
    const handleOtpSubmit = async () => {
        if (!OTP) {
            notify("Please enter OTP");
            return true;
        }
        if (OTP.length == 6) {
            const params = {
                mobile_no: `91${mobileNo}`,  // Add 91 as a prefix
                otp: OTP,
            };
            setLoading(true);
            const response = await signInApi(params);
            if (response.data.success == true) {
                setLoading(false);
                navigate("/dashboard");
                setTimeout(async () => {
                    try {
                      const moduleResponse = await getModule();
                      localStorage.setItem('moduleList', JSON.stringify(moduleResponse.data.payload));
                      console.log("Module list stored in localStorage:", moduleResponse.data.payload);
                    } catch (moduleError) {
                      console.error("Failed to fetch module list:", moduleError);
                      notify("Failed to load module list.");
                    }
                }, 500); 
                dispatch(
                    setUserDetails({
                        firstName: response.data.payload.first_name,
                        lastName: response.data.payload.last_name,
                        email: response.data.payload.email,
                        mobileNoRe: response.data.payload.mobile_number,
                        token: response.data.payload.token,
                        id: response.data.payload.id,
                        MFA_UserId: response.data.payload.mfa_user_id,
                        company_logo: response.data.payload.company_logo,
                        companyId: response.data.payload.company_id,
                        is_super_admin: response.data.payload.is_super_admin,
                        is_admin: response.data.payload.is_admin,
                        companyName: response.data.payload.company_name,
                        companyDescription: response.data.payload.company_description,
                        user_access:
                            response.data.payload.user_access?.access_module_management || [],
                        company_access: response.data.payload.user_access?.company_access || [],
                        plant_access: response.data.payload.user_access?.plant_access || [],
                        user_country: response.data.payload.user_country,
                        user_country_name: response.data.payload.user_country_name,
                        user_country_code_name:
                            response.data.payload.user_country_code_name,
                        user_country_code: response.data.payload.user_country_code,
                        user_country_currency: response.data.payload.user_country_currency,
                        user_country_currency_name:
                            response.data.payload.user_country_currency_name,
                        user_country_currency_symbol:
                            response.data.payload.user_country_currency_symbol,
                        is_created_by_super_admin_user_company:
                            response.data.payload.is_created_by_super_admin_user_company,
                        is_renewable_energy: response.data.payload.is_renewable_energy,
                        is_csv_record_access : response.data.payload.is_csv_record_access,
                        is_normal_user: response.data.payload.is_normal_user,
                        is_printer_status_access:response.data.payload.is_printer_status_access,

                    })
                );
            }

            if (response.data.success == false) {
                setLoading(false);
                notify(response.data.message);
            }
        } else {
            notify("Please Enter valid OTP.");
        }

    };

    return (
        <>
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
                    <div className="pb-2">
                        <img src={images.logo} alt="" className="signIn-logo" />
                    </div>
                    <h3 className="text-center singIn-title">Welcome</h3>
                    <p className="text-center otp-title" >OTP</p>
                    <ValidatorForm>
                        <div className="otp-input wrap">
                            <OTPInput
                                value={OTP}
                                onChange={setOTP}
                                autoFocus
                                OTPLength={6}
                                otpType="number"
                                disabled={false}
                                secure={!visibleOTP}
                                className="OTP"
                                inputStyle="xyz"
                            />
                            {visibleOTP ? (
                                <img
                                    src={images.viewIcon}
                                    alt=""
                                    className="view icon OTP"
                                    onClick={() => setvisibleOTP(false)}
                                />
                            ) : (
                                <img
                                    src={images.eyecloseIcon}
                                    alt=""
                                    className="view icon OTP"
                                    onClick={() => setvisibleOTP(true)}
                                />
                            )}
                        </div>
                        <div className="countdown-text d-flex justify-content-center pt-4 pb-4">
                            {seconds > 0 ? (
                                <>
                                    <p className="d-flex" style={{ marginLeft: "50px" }}>
                                        Please wait for {seconds < 10 ? `0${seconds}` : seconds}{" "}
                                        seconds
                                    </p>
                                </>
                            ) : (
                                <div
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                    className="abc"
                                >
                                    <div>Didn't recieve code?</div>
                                    <div>
                                        <a
                                            style={{
                                                cursor: "pointer",
                                                textDecorationLine: "underline",
                                                fontWeight: 500,
                                            }}
                                            onClick={() => handleResendOTp()}
                                        >
                                            Resend
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>

                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            className="pb-5"
                            style={{ justifyContent: "space-between" }}
                        >
                            <Grid item xs={6}>
                                <div
                                    onClick={() => onCancelClick()}
                                >
                                    <Button title="cancel" classname={"border-btn"} />
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div
                                    onClick={() => handleOtpSubmit()}
                                >
                                    <Button title="Submit" classname={"custom-button"} />
                                </div>
                            </Grid>
                        </Grid>
                    </ValidatorForm>
                    <PrivacyPolicy />
                </Grid>
            </Grid>
            {isLoading && <Loader />}


        </>
    )
}

export default LoginWithOtp;